<div class="side-bar-container d-flex">
  <div class="side-bar collapsed" [class.collapsed]="collapsed">
    <div class="inner">
      <div class="logo-holder">
        <a [routerLink]="['/dashboard']">
          <img src="./assets/img/logo.webp" class="logo" />
          <img src="./assets/img/logo_small.png" class="logo-small" />
        </a>
      </div>
      <nav [class.prod-margin]="environment() === Environment.PROD && serviceType === ServiceType.CLOUD">
        <ng-content select="[slot=sidebar]"></ng-content>
      </nav>
      <a class="btn text-dark toggle" (click)="toggleCollapse()">
        <span class="icon material-icons-outlined"></span>
      </a>
    </div>
  </div>
  <nav class="mobile-nav position-fixed" [class.expanded]="mobileExpanded">
    <div class="d-flex flex-column h-100">
      <div class="bg-white mobile-header">
        <div (click)="toggleMobileNav()" class="menu-icon material-symbols-outlined">menu</div>
        <div class="d-flex flex-grow-1 justify-content-center">
          <img [routerLink]="['/dashboard']" routerLinkActive="active" src="./assets/img/logo.webp" class="logo" />
        </div>
      </div>
      <ng-content select="[slot=mobile]"></ng-content>
      <div class="overlay" [class.expanded]="mobileExpanded" (click)="toggleMobileNav()"></div>
    </div>
  </nav>
  <div id="content" [style.height]="showEnvironment() ? 'calc(100% - 20px - 14px)' : 'calc(100% - 14px)'">
    @if (showEnvironment()) {
    <div class="d-flex justify-content-end pe-1" style="color: red; font-size: 0.9em; height: 20px;">
      <span class="fw-bold">Backend: {{environment()}}</span>
    </div>
    }
    <div class="root-container">
      <router-outlet></router-outlet>
    </div>
    <div class="fw-light d-flex gap-1 justify-content-end pe-1"
      style="right: 0.2rem; color: gray; font-size: 0.6em; height: 14px;">
      <a [href]="'status_page.url' | translate" target="_blank">{{ 'status_page.label' | translate }}</a>
      <span>◦</span>
      <a href="javascript:void(0)" #sentryButton>{{ 'report_issue' | translate }}</a>
      <span>◦</span>
      <a [href]="'imprint.url' | translate" target="_blank">{{ 'imprint.label' | translate }}</a>
      <span>◦</span>
      <a [href]="'privacy.url' | translate" target="_blank">{{ 'privacy.label' | translate }}</a>
      <span>◦</span>
      <a [href]="'terms.url' | translate" target="_blank">{{ 'terms.label' | translate }}</a>
      <span>◦</span>
      <a [routerLink]="['/licenses']">{{ 'licenses.title' | translate }}</a>
      @if (frontendVersion || backendVersion) {
      <span>|</span>
      }
      @if (frontendVersion) {
      <span>F.{{frontendVersion.tag ? frontendVersion.tag : frontendVersion.hash}}</span>
      }
      @if (frontendVersion && backendVersion) {
      <span>◦</span>
      }
      @if (backendVersion) {
      <span>B.{{backendVersion.tag ? backendVersion.tag : backendVersion.hash}}</span>
      }
    </div>
  </div>
</div>

<app-offline-toast></app-offline-toast>
